module.exports = __webpack_public_path__ + "static/media/file-import.96b28ec4.png";